import { useContext, useMemo } from "react"
import { FeatureFlagContext } from "../../../../mp-core/FeatureFlagProvider"
import { FILTERS_BY_ROUTE } from "../../../constants"
import { getFiltersByRouteUnderFeatureFlag } from "../helpers"

export const useReportingFiltersUnderFeatureFlag = () => {
  const { featureFlags, featureFlagsLoading } = useContext(FeatureFlagContext)

  const filtersByRoute = useMemo(() => {
    if (featureFlagsLoading) {
      return FILTERS_BY_ROUTE
    }

    return getFiltersByRouteUnderFeatureFlag(featureFlags || {})
  }, [featureFlags, featureFlagsLoading])

  return filtersByRoute
}
